export default __webpack_public_path__ + "static/media/mob_background.172db210.png";